import { observer } from "mobx-react-lite";
import { useTranslation } from "../i18n/useTranslation.js";
import { HOW_IT_WORKS } from "../content/landingContent.js";
import FeatureGrid from "./FeatureGrid.js";
import SectionHeading from "./SectionHeading.js";

const HowSection = observer(() => {
  const { t } = useTranslation();
  return (
    <section id="how-it-works" className="landing-section landing-process-section">
      <SectionHeading eyebrow={t("landing.how.eyebrow")} title={t("landing.how.title")} body={t("landing.how.body")} />
      <FeatureGrid items={HOW_IT_WORKS} />
    </section>
  );
});

export default HowSection;
